const PublicTransportVehicleEstimator: React.FC = () => {
    return (
        <iframe height="315" src="https://www.youtube.com/embed/-zPv_5N0pY8" title="YouTube video player" frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>
    );
}

export default PublicTransportVehicleEstimator;